/**
 * Static content for the Notice of Medicare Non-Coverage (NOMNC): the notice
 * wording and the appeal instructions are printed text mandated by CMS, not
 * captured answers, so they live in the frontend. Every `key` below matches a
 * column on the backend.
 */

export const NON_COVERAGE_REASONS = [
  {
    key: "reasonSkilledServicesNotRequired",
    title: "Skilled services no longer required",
    description:
      "The patient has reached a clinical plateau or met established therapy/nursing goals.",
  },
  {
    key: "reasonNoLongerHomebound",
    title: "Patient is no longer homebound",
    description:
      "Clinical assessment indicates the patient is able to leave the home without taxing effort for non-medical reasons.",
  },
  {
    key: "reasonDocumentationNotSupported",
    title: "Documentation does not support medical necessity",
    description:
      "Interventions do not meet the criteria for reasonable and necessary skilled care under Medicare Part A.",
  },
];

/** The immediate-review paragraph, printed verbatim on the notice. */
export const APPEAL_INSTRUCTIONS =
  "If you think your services should not end, you have the right to an immediate review by a Quality Improvement Organization (QIO). You must contact the QIO no later than noon of the day before your coverage ends.";

export const APPEAL_DEADLINE_NOTE =
  "Deadline: 12:00 PM on the day prior to end date.";

/** Shown above the signature block — receipt is not agreement. */
export const ACKNOWLEDGEMENT_STATEMENT =
  "By signing below, you are acknowledging that you have received this notice. Your signature does not mean that you agree with this notice.";
